/*jshint esversion: 6 */
(function () {
    'use strict';
    $(function () {

        var chart;
        var isMobileView = false;

        $(document).ready(function () {

            if (!$('.country-comparison').length) return;

            chart = initLine();
            isMobileView = $(".chart").width() < 550;

            setRegionsSelect();

            showChartTooltip(1, 5000);
            showChartTooltip(2, 10000);
            showChartTooltip(0, 15000);


            //set URL args to first select boxes
            var currentUrl = new Url();
            if (currentUrl.query.size) {
                $('input[name="size"][value="' + currentUrl.query.size + '"]').prop("checked", true);
            }

            if (currentUrl.query.theme) {
                $('input[name="theme"][value="' + currentUrl.query.theme + '"]').prop("checked", true);
                var optionText = $('input[name="theme"][value="' + currentUrl.query.theme + '"]').siblings('label').text();
                $('.dropdown-box-toggle').html(optionText);
            }

            $('.radio-container').change(function () {
                showGraphs();
            });

            $('input[name="theme"]').change(function () {
                showGraphs();
            });

            $('.clear-selection').on('click', ()=>{
                $("#regions input[type=checkbox]:checked").prop("checked", false);
                $('input[name="theme"][value="ENV"]').prop("checked", true);
                $('.dropdown-box-toggle').html('Environment');
                $('.size-picker input[type="radio"]:checked').prop("checked", false);
                $('.size-picker input.default').prop("checked", true);
                $(".selected-container").empty();
                showGraphs();
            });


            $('.chart-tooltip').on('click', function () {
                $('.chart-tooltip').each(function () {
                    $(this).fadeOut(1000);
                });
            });

        });

        function showChartTooltip(index, timeout) {
            setTimeout(function () {
                $('.chart-tooltip').eq(index).fadeIn(1000);
            }, timeout);
        }

        function showGraphs() {

            var regions = [];
            var graphs = [];
            var size = $('.radio-container input[type=radio]:checked').val();

            $(".selected-container").empty();

            $("#regions input[type=checkbox]:checked").each(function () {

                var $this = $(this);
                var regionName = $(this).val();
                var selectOptions = "";
                var sizeLabel = "";
                if (size === "L")
                    sizeLabel = "Large";
                else if (size === "SM")
                    sizeLabel = "Small/Medium";
                else
                    sizeLabel = "All";

                selectOptions += "<button class='active-country query-modifier' value='" + regionName + "'>" + regionName + "</button>";

                $(".selected-container").append(selectOptions);

                $('.active-country').on('click', function () {
                    if ($(this).val() === regionName) {
                        var removedRegion =  $(this).val();
                        $("#regions input[name='regions'][value='"+removedRegion+"']").prop( "checked", false );
                        $(this).remove();
                        var regionValues = [];
                        $('.active-country').each(function () {
                            regionValues.push($(this).attr('value'));
                        });
                        setUrl("regions", regionValues);
                        showGraphs();
                    }
                });

                regions.push(regionName);

                graphs.push({
                    // "balloonText": "<span style='font-size:12px;'>[[title]] in [[category]]:</span><br><span style='font-size:14px;'>[[value]]</span><br><span style='font-size:10px; font-weight: bold'>[[additional]]</span>",
                    "balloonFunction": function (data, serie) {
                        var value = Number(parseFloat(data.dataContext[serie.valueField]).toFixed(1));
                        var additional = "";
                        if (data.dataContext[regionName + "-additional"]) {
                            additional = "<br><span style='font-size:10px; font-weight: bold'>" + data.dataContext[regionName + "-additional"] + "</span>";
                        }
                        return "<span style='font-size:12px;'>" + serie.title + " in " + data.category + ":</span><br><span style='font-size:14px;'>" + value + "</span>" + additional;
                    },
                    "title": regionName + ", " + sizeLabel,
                    "type": "column",
                    "valueField": regionName + ' - ' + size,
                    "lineThickness": 0,
                    "fillAlphas": 1,
                    "fixedColumnWidth": isMobileView ? 10 : 20
                });
            });

            callAjax(
                {
                    action: "get_countries_data",
                    theme: $('input[name=theme]:checked').val(),
                    size: size,
                    regions: regions
                },
                function (response) {
                    changeChartTitle();
                    chart.graphs = graphs;
                    chart.dataProvider = JSON.parse(response.responseText);
                    chart.validateData();
                    chart.animateAgain();
                }
            );
        }

        function setRegionsSelect() {
            callAjax(
                {
                    action: "get_countries_for_countries_view"
                },
                function (response) {
                    var areasGroups = JSON.parse(response.responseText);

                    var currentUrl = new Url();
                    var selectOptions = "";

                    areasGroups.forEach(function (areasGroup, i) {

                        if (i == 0) {
                            selectOptions += "<label class=\"container container-label\">Regions:</label>";
                        } else {
                            selectOptions += "<label class=\"container container-label\">Countries:</label>";
                        }

                        areasGroup.forEach(function (area, j) {
                            var selected = "";

                            // check if regions in URL
                            if (currentUrl.query.regions) {
                                if (Array.isArray(currentUrl.query.regions)) {
                                    var urlRegions = currentUrl.query.regions;
                                    for (var region in urlRegions) {
                                        if (area === urlRegions[region]) {
                                            selected = " checked ";
                                        }
                                    }
                                }
                            } else {
                                if (area === "World")
                                    selected = " checked ";
                            }

                            selectOptions += "<label class=\"container\">" + area + "" +
                                " <input type=\"checkbox\" " + selected + " name=\"regions\" value=\"" + area + "\">" +
                                " <span class=\"checkmark\"></span>" +
                                " </label>";
                        });

                    });

                    $("#regions").append(selectOptions);

                    showGraphs();

                    $('#regions input').change(function () {
                        if ($("#regions input:checked").length > 6) {
                            swal(
                                "Oops",
                                "You can't add more than 6 regions.",
                                "warning"
                            );
                            $(this).prop('checked', false);
                            return false;
                        } else {
                            showGraphs();
                        }
                    });
                }
            );
        }

        $('#select-box').on('click', function () {
            $(this).find('.select-container').fadeIn();
        });

        $('.dropdown-box .dropdown-box-toggle').on('click', function () {
            $(this).siblings('.dropdown-box .dropdown-box-list').slideToggle();
        });

        $('.dropdown-box .dropdown-box-list-option').on('click', function () {
            var optionText = $(this).find('label').html();
            $(this).parent().siblings('.dropdown-box-toggle').html(optionText);
        });

        function changeChartTitle() {
            var newTitle = $("input[name=theme]:checked").siblings('label').text();
            chart.allLabels[0].text = newTitle;
            chart.allLabels[0].fontSize = 18;
        }

        function initLine() {
            return AmCharts.makeChart("country-chart", {
                "titles": [
                    {
                        "text": ".",
                        "size": 28,
                        "color": "transparent"
                    }
                ],
                "allLabels": [{
                    "text": "",
                    "bold": true,
                    "x": 0,
                    "y": 0,
                    "rotation": 0,
                    "align": "left",
                    "size": 18,
                    "color": "#4A4A49"
                },{
                    "text": "(Hover over the chart to view the values)",
                    "bold": false,
                    "x": 0,
                    "y": 25,
                    "rotation": 0,
                    "align": "left",
                    "size": 14,
                    "color": "#4A4A49"
                }],
                "type": "serial",
                "theme": "light",
                "colors": ["#5CD982", "#FFCC50", "#00A6FB", "#FF6A4C", "#A6A6A6", "#660099"],
                "balloon": {
                    "horizontalPadding": 10,
                    "verticalPadding": 8,
                },
                "legend": {
                    "position": "bottom",
                    "fontSize": 12
                },
                "dataProvider": [],
                "graphs": [],
                "categoryAxis": {
                    "gridPosition": "start",
                    "axisColor": "#d9d9d9",
                    "axisThickness": 2,
                    "fontSize": 10
                },
                "valueAxes": [{
                    "position": "left",
                    "axisColor": "#d9d9d9",
                    "color": "#4A4A49",
                    "tickLength": 2,
                    "labelFrequency": 2,
                    "autoGridCount": false,
                    "fontSize": 12
                }],
                "categoryField": "year",
                "startEffect": 'easeOutSine',
                "startDuration": 1,
                "sequencedAnimation": true,
                "chartCursor": {
                    "enabled": true
                },
                "numberFormatter": {
                    "precision": 1
                },
                // "guides": [
                //     {
                //         "fillAlpha": 0.4,
                //         "label": 53,
                //         "value": 53,
                //         "toValue": 53,
                //         "dashLength": 3,
                //         "color": "#4A4A49",
                //         "LabelColor": "#4A4A49",
                //         "lineThickness": 2,
                //         "boldLabel": true
                //     }
                // ],
                "responsive": {
                    "enabled": true,
                    "rules": [{
                        "maxWidth": 550,
                        "overrides": {
                            "labelsEnabled": false,
                            "legend": {
                                "enabled": true,
                                "position": "bottom",
                                "fontSize": 8,
                            },
                            "fontSize": 8,
                            "rotate": 90,
                            "categoryAxis": {
                                "fontSize" : 8,
                            },
                            "valueAxes": {
                                "fontSize" : 8
                            },
                            "export": {
                                "enabled": false,
                                "menu": false,
                            },
                        }
                    }]
                },

                "export": {
                    "enabled": true,
                    "menu": [{
                        "class": "export-custom",
                        "format": "JPG",
                        "label": "Download the View",
                        "title": "Export chart to JPG",
                    }],
                    "beforeCapture": function (menuConfig) {
                        var url = "data:image/png;base64,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";
                        var setup = this.setup;
                        var timer = setInterval(function () {
                            if (setup.fabric) {
                                var canvas = setup.fabric;
                                clearTimeout(timer);
                                canvas.setOverlayImage(url, canvas.renderAll.bind(canvas), {
                                    scaleX: 1,
                                    scaleY: 1,
                                    top: 70,
                                    left: 60,
                                    originX: 'left',
                                    originY: 'top',
                                });
                            }
                        }, 100);
                    }
                },
                "creditsPosition": "top-right"
            });
        }

    });
}(jQuery));
